// extracted by mini-css-extract-plugin
export var info = "Person-module--info--74e37";
export var mascotAnimationDelay = "Person-module--mascot-animation-delay--512f8";
export var mascotAnimationIdle = "Person-module--mascot-animation-idle--51571";
export var mascotAnimationIn = "Person-module--mascot-animation-in--7412a";
export var mascotAnimationOut = "Person-module--mascot-animation-out--37b7f";
export var person = "Person-module--person--392b1";
export var personAvatar = "Person-module--personAvatar--95746";
export var personAvatarIdle = "Person-module--personAvatarIdle--60e43";
export var personSizeXl = "Person-module--personSizeXl--c2871";
export var personSizeXlUltraWide = "Person-module--personSizeXlUltraWide--0de28";
export var personSizeXlWide = "Person-module--personSizeXlWide--c5482";
export var personVariation1 = "Person-module--personVariation1--6d341";
export var personVariation2 = "Person-module--personVariation2--749df";
export var personVariation3 = "Person-module--personVariation3--be573";
export var personVariation4 = "Person-module--personVariation4--97457";
export var personVariation5 = "Person-module--personVariation5--1badc";
export var photo = "Person-module--photo--24ec7";
export var photoWrap = "Person-module--photoWrap--a7af0";